import { EditProfile } from "components/Profile";
import React from "react";

export const HotelProfile: React.FC = () => {
  return <EditProfile />;
};
